var map = {
	"./10x_lg.jpg": "b553",
	"./10x_md.jpg": "6c95",
	"./10x_sm.jpg": "7147",
	"./tranquilo_lg.jpg": "e26c",
	"./tranquilo_md.jpg": "127f",
	"./tranquilo_sm.jpg": "9914",
	"./vaidesn_lg.jpg": "f9ac",
	"./vaidesn_md.jpg": "951c",
	"./vaidesn_sm.jpg": "a6df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8306";